<main class="log-in">
   <div class="left-side">
      <img src="../../assets/images/Crossplag_Logo_Negativ.png" alt="" />
      <div>
         <h1>The most advanced & affordable plagiarism checking tool.</h1>
         <p [innerHtml]="'login.crossplag_description' | translate">
         </p>
      </div>
      <h6>© All rights reserved - Crossplag™</h6>
      <svg
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 1037.98 1031.18"
         width="1037.98"
         height="1031.18"
      >
         <defs>
            <style>
               .a {
                  fill: #fff;
                  opacity: 0.1;
               }
            </style>
         </defs>
         <path
            class="a"
            transform="translate(-93 -95.546)"
            d="M 1051.52 401.347 q -75.5 -75.5 -149.927 -77.66 c -1.079 -22.291 -7.191 -44.942 -17.977 -68.312 c -12.224 -26.606 -31.28 -52.852 -57.526 -79.1 c -48.9 -48.9 -100.311 -75.5 -153.522 -80.177 C 619 91.786 569.386 112.639 523.006 158.66 q -30.2 30.2 -50.695 72.267 q -20.494 42.6 -25.887 103.546 a 596.2 596.2 0 0 0 -1.079 62.919 c 0.36 7.55 0.36 15.1 0.719 23.01 c 0.36 15.46 0.719 32 1.438 48.178 c 1.079 24.448 1.8 49.616 2.517 75.143 s 0.36 50.695 -1.079 75.5 c -2.157 29.482 -6.112 52.852 -12.584 69.39 C 430.964 703 422.335 716.66 410.83 729.244 l -10.067 10.067 q -69.031 64.717 -140.219 -6.112 c -26.246 -26.246 -39.549 -51.773 -40.268 -76.581 c 0 -48.178 29.123 -67.233 29.123 -67.233 c 35.954 -35.954 168.982 -34.156 168.982 -34.156 l -5.753 -80.9 c -0.719 -11.865 -11.505 -16.179 -23.37 -17.258 c 0 0 -141.3 -16.539 -231.182 55.728 c 0 0 -65.076 46.74 -65.076 151.005 c 2.876 54.29 29.122 106.782 79.458 157.117 s 100.311 76.222 149.927 77.66 c 1.079 22.291 7.191 44.942 17.977 68.312 c 12.224 26.606 31.28 52.852 57.526 79.1 c 48.9 48.9 100.311 75.5 153.522 80.177 c 53.571 4.314 103.187 -16.539 149.567 -62.559 q 30.2 -30.2 50.695 -72.267 q 20.494 -42.605 25.887 -103.546 a 596.153 596.153 0 0 0 1.079 -62.919 c -0.719 -22.651 -1.438 -46.38 -2.517 -70.829 v -2.517 c -1.078 -23.729 -1.438 -47.818 -2.157 -72.626 q -1.079 -38.291 1.079 -75.5 c 2.157 -29.482 6.112 -52.852 12.584 -69.391 c 5.393 -14.381 14.022 -28.044 25.527 -40.628 l 10.067 -10.067 q 69.031 -64.717 140.219 6.112 c 26.246 26.246 39.549 51.773 40.268 76.581 c 0 48.178 -29.122 67.233 -29.122 67.233 C 938.63 669.2 805.6 667.4 805.6 667.4 l 5.753 80.9 c 0.719 11.865 11.865 16.9 23.37 17.258 c 0 0 141.3 16.539 231.182 -55.728 c 0 0 65.076 -46.74 65.076 -151.005 C 1128.46 503.815 1101.86 451.682 1051.52 401.347 Z m -293.741 -23.37 a 284.893 284.893 0 0 0 -21.932 20.134 c -20.853 20.853 -38.471 44.942 -53.931 72.267 Q 659.27 511.9 652.8 569.61 c -1.8 16.539 -2.876 54.65 -2.876 54.65 c 0 4.314 -0.36 8.629 -0.36 12.943 q 0 37.212 2.157 75.5 c 1.438 25.527 2.517 50.335 3.6 75.143 c 1.079 24.448 1.079 46.74 0.359 66.874 c -0.719 32.358 -4.314 56.807 -11.505 73.345 c -6.831 16.539 -15.82 30.2 -26.965 41.347 c -18.7 18.7 -39.189 27.684 -61.481 27.325 s -45.661 -12.584 -69.75 -36.673 c -39.909 -39.909 -46.74 -78.738 -19.774 -116.49 c 6.831 -7.191 13.662 -14.022 20.853 -21.213 c 20.853 -20.853 39.909 -43.5 55.009 -71.188 s 24.808 -60.762 29.122 -99.232 a 633.525 633.525 0 0 0 3.236 -67.233 c 0 -11.865 0 -24.448 -0.359 -36.313 c -0.36 -12.943 -0.719 -26.246 -1.438 -39.189 c -1.438 -25.527 -2.517 -50.335 -3.6 -75.143 c -1.079 -24.448 -1.079 -46.74 -0.36 -66.874 c 0.719 -32.358 4.314 -56.807 11.505 -73.345 c 6.831 -16.539 15.82 -30.2 26.965 -41.347 c 18.7 -18.7 39.189 -27.684 61.481 -27.325 s 45.661 12.584 69.75 36.673 C 778.277 301.755 791.939 340.226 757.783 377.977 Z"
         />
      </svg>
   </div>
   <div class="right-side">
      <img
         src="../../assets/images/Crossplag_Logo.png"
         alt=""
      />
      <span routerLink="/login" class="go-back"> <i class="fas fa-arrow-left"></i> Go back</span>
<div class="form-container">
   <h3>Reset Password</h3>
   <div>
      <p>{{ 'login.reset_link' | translate }}</p>
   </div>
   <div [formGroup]="forgotForm">
      <input formControlName="email" placeholder="Email" />
   </div>
   <div
      *ngIf="FormValues.email.touched && FormValues.email.invalid"
      class="alert alert-danger"
   >
      <div class="invalid" *ngIf="FormValues.email.errors.required">
         {{ 'validators.enter_email' | translate }}
      </div>
      <div class="invalid" *ngIf="FormValues.email.errors.email">
         {{ 'validators.valid_email' | translate }}
      </div>
   </div>

   <ng-container *ngIf="forgotForm.valid">
      <button (click)="submit()" class="submit" type="submit">
         {{ 'general.reset_password' | translate }}
      </button>
   </ng-container>

   <ng-container *ngIf="forgotForm.invalid">
<div class="center">
   <button
   (click)="showToasterWarning('Please enter a valid email')"
   class="submit"
   type="submit"
>
   {{ 'general.reset_password' | translate }}
</button>
</div>
   </ng-container>
</div>
   </div>
</main>
